import React from 'react';
import { IconProps } from '.';

const SvgTrash = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M9.25 18v-8h1.5v8h-1.5ZM13.25 10v8h1.5v-8h-1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M8.25 4.667c0-1.968 1.764-3.417 3.75-3.417s3.75 1.45 3.75 3.417v.583H22v1.5h-1.329l-1.777 16H5.107l-1.778-16H2v-1.5h6.25v-.583ZM4.838 6.75l1.611 14.5h11.102l1.611-14.5H4.838Zm9.412-2.083v.583h-4.5v-.583c0-.978.922-1.917 2.25-1.917 1.328 0 2.25.939 2.25 1.917Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTrash;
